import { LogEntry } from '@src/api/models/LogEntry';
import { BackendLogLevel } from '@src/api/models/BackEndLogEnum';

export namespace Outgoing {
	export interface SendObjectData {
		data: Record<string, any>;
		tags: string[];
		stackTrace: string;
		immediately?: boolean;
	}

	interface SendObjectMeta {
		text: string;
		logLevel: BackendLogLevel;
		timeStamp: string;
	}

	// todo: enable this later :>
	// const myDeviceId = v4();

	const outgoingEntries: LogEntry[] = [];

	// TODO timer repeat

	/**
	 * @description
	 * Adds a data chunk to an entry collection. These are then sent
	 * to SEQ by a recurring task, or immediately if told / is error.
	 *
	 * @param sendData data to be sent.
	 */
	export function addEntry({
		data,
		logLevel,
		stackTrace,
		tags,
		text,
		timeStamp,
		immediately = false,
	}: SendObjectMeta & SendObjectData): void {
		const entry: LogEntry = {
			Data: data,
			Timestamp: timeStamp,
			Tags: tags,
			Text: `[Public v4.0.0] ${text}`,
			StackTrace: stackTrace,
			LogLevel: logLevel,
		};

		if (immediately || logLevel === BackendLogLevel.Error) {
			sendBatch([entry]);
		} else {
			outgoingEntries.push(entry);
		}
	}

	function sendBatch(_batch: LogEntry[]): void {
		// const body = {
		// 	DeviceId: myDeviceId,
		// 	ApiSessionToken: null,
		// 	DeviceInfo: {
		// 		AppBuild: null,
		// 		AppVersion: null,
		// 		Browser: platform.name,
		// 		BrowserVersion: platform.version,
		// 		AppName: null,
		// 		DeviceName: null,
		// 		Os: platform.os ? platform.os.family : null,
		// 		OsVersion: platform.os ? platform.os.version : null,
		// 		Platform: 'JavaScript',
		// 	},
		// 	Entries: batch,
		// };
		// Not using the HttpClient to avoid circular imports
		// Ignores the request for RR pilot
		// Axios.post(`${Environment.loadProperty('apiRoot')}/api/General/DeviceLog`, JSON.stringify(body), httpOptions.requestConfig);
	}
}
